export default function Services() {
  const services = [
    {
      title: "Design & Project Management",
      items: [
        "Mood boards & concept creation",
        "2D floor plans & 3D renderings",
        "Working drawings & detailed documentation",
        "Full project supervision and execution",
      ],
    },
    {
      title: "Fine Finishes & Fit-Out",
      items: [
        "Interior finishing with premium materials",
        "Epoxy and insulation services",
        "Professional craftsmanship with fast delivery",
        "Execution under expert engineering supervision",
      ],
    },
    {
      title: "Furnishing Services",
      items: [
        "Complete furnishing packages",
        "Custom art direction & styling",
        "Luxury furniture solutions tailored to each project",
      ],
    },
    {
      title: "Supply & Installation",
      items: [
        "High-quality chemicals & construction materials",
        "Authorized distributor for leading brands (CMB, Prokem, BASF, Sika, and others)",
      ],
    },
  ];

  return (
    <section className="container mx-auto px-4 py-16">
      {/* Section Title */}
      <h2 className="text-4xl font-bold text-center mb-16  decoration-gray-300 underline-offset-8 pb-3 w-fit mx-auto">
        Services
      </h2>

      {/* Services Grid */}
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        {services.map((service, index) => (
          <div
            key={index}
            className="p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 
                shadow-md hover:bg-white/10 hover:shadow-xl transition-all duration-500"
          >
            <h3
              className="text-xl font-semibold text-center mb-6 text-gray-100 
                    underline decoration-gray-400 underline-offset-4"
            >
              {service.title}
            </h3>
            <ul className="list-disc list-inside space-y-2 text-gray-300">
              {service.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
